import React, { useContext } from "react";
import "./Navbar.css";
import Logo from "./Logo";
import Button from "./Button";
import Cart from "./Cart";
import { Link, useLocation } from "react-router-dom";
import { ShopContext } from "../../../context/ShopContext";

const CATEGORY_TO_MENU = {
    cake: "cake",
    tailoring: "tailor",
};

const Navbar = ({ toggle }: { toggle: () => void }) => {

    // Highlight is derived from the actual route, not click state, so it stays
    // correct when a page is reached any other way (e.g. a product link, or a
    // submenu tab navigating straight to /cake or /tailor). Product pages
    // (/product/:id) also highlight their category, so viewing a cake still
    // shows "Cakes" as the active section.
    const { pathname } = useLocation();
    const { all_product } = useContext(ShopContext);
    const productMatch = pathname.match(/^\/product\/(\d+)/);
    const productCategoryMenu = productMatch
        ? CATEGORY_TO_MENU[all_product.find((p) => p.id === Number(productMatch[1]))?.category]
        : null;

    const menu = pathname === "/" ? "shop"
        : pathname.startsWith("/cake") ? "cake"
        : pathname.startsWith("/tailor") ? "tailor"
        : pathname.startsWith("/gallery") ? "gallery"
        : productCategoryMenu;

    return (
        <>
            <div className="navbar-container w-full sticky top-0 bg-white">
                <div className="navbar">
                    <div className="nav-logo">
                        <Logo />
                    </div>


                    <div className="nav-container-md inline-flex space-x-4 lg:hidden">
                        <div className="test">
                            {/* <div className="nav-login-cart hidden lg:flex"> */}
                            <div className="nav-login-cart">
                                {/* <Button /> */}
                                <Cart />
                            </div>
                        </div>
                        <button
                            type="button"
                            onClick={toggle}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    fill="#008B8B"
                                    d="M3 6h18v2H3V6m0 5h18v2H3v-2m0 5h18v2H3v-2Z"
                                />
                            </svg>
                        </button>
                    </div>

                    <div className="nav-container-lg hidden lg:flex space-x-4">
                        <ul className="nav-menu">
                            <li><Link style={{ textDecoration: 'none' }} to='/'>Popular</Link>{menu === "shop" ? <hr /> : <></>}</li>
                            {/* <li><Link style={{ textDecoration: 'none' }} to='/sweet'>Sweets</Link>{menu === "sweet" ? <hr /> : <></>}</li>
                            <li><Link style={{ textDecoration: 'none' }} to='/semi-sweet'>Semi-Sweets</Link>{menu === "semi-sweet" ? <hr /> : <></>}</li>
                            <li><Link style={{ textDecoration: 'none' }} to='/snack'>Snacks</Link>{menu === "snack" ? <hr /> : <></>}</li> */}
                            <li><Link style={{ textDecoration: 'none' }} to='/cake'>Cakes</Link>{menu === "cake" ? <hr /> : <></>}</li>
                            <li><Link style={{ textDecoration: 'none' }} to='/tailor'>Tailoring</Link>{menu === "tailor" ? <hr /> : <></>}</li>
                            <li><Link style={{ textDecoration: 'none' }} to='/gallery'>Gallery</Link>{menu === "gallery" ? <hr /> : <></>}</li>

                        </ul>
                    </div>

                    <div className="nav-container-lg hidden lg:flex space-x-4">
                        <div>
                            <div className="nav-login-cart">
                                {/* <Button /> */}
                                <Cart />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Navbar;